import {useEffect, useState} from "react";
import {Html5Qrcode} from "html5-qrcode";
import './html5.css'
import Button from "@mui/material/Button";

export const QrReaderC = ({setQrCodeResult}) => {
    const [isEnabled, setEnabled] = useState(false)
    const [permission, setPermission] = useState(false)


    async function askForPermission() {
        const permission = await navigator.mediaDevices.getUserMedia({video: true});
        if (permission) {
            setPermission(true)
            setEnabled(true)
        }
    }

    async function checkForPermission() {
        const status = await navigator.permissions.query({name: 'camera'});
        console.log(status)
        // Check if permission is already granted
        if (status.state === 'granted') {
            setPermission(true)
            setEnabled(true)
        }
    }

    useEffect(() => {
        checkForPermission()
    }, [])

    useEffect(() => {
        if (!isEnabled) return
        const config = {fps: 10, qrbox: 250, aspectRatio: 1};
        const html5QrCode = new Html5Qrcode("qrCodeContainer");

        const qrScannerStop = () => {
            if (html5QrCode && html5QrCode.isScanning) {
                html5QrCode.stop().then(() => {
                    console.log("scanner Stop")
                })
                    .catch(() => console.log("Scanner error"))
            }
        }

        const qrCodeSuccess = (decodeText) => {
            setQrCodeResult(decodeText)
            console.log(decodeText)
            setEnabled(false)
        }

        if (isEnabled) {
            html5QrCode.start({facingMode: "environment"}, config, qrCodeSuccess, (error) => {
                // console.log("Ошибка чтения QR-кода:", error);
            })
            setQrCodeResult('')
        } else {
            qrScannerStop()
        }
        return (() => {
            qrScannerStop()
        })
    }, [isEnabled])

    return (
        <div className={"wrapperScanner"}>
            {permission ?
                <div id={"qrCodeContainer"} style={{width: '300px', height: '300px', maxWidth: 300}}></div>
                :
                <Button onClick={() => askForPermission()}>Dozvoli video pristup</Button>
            }
        </div>
    )
}
